var _a;
import { SearchDocumentType } from '../../api/api.types';
var totalCounts = (_a = {},
    _a[SearchDocumentType.Pages] = 73,
    _a[SearchDocumentType.Products] = 64,
    _a[SearchDocumentType.Blogs] = 58,
    _a[SearchDocumentType.Forums] = 46,
    _a[SearchDocumentType.Bookings] = 31,
    _a[SearchDocumentType.Events] = 23,
    _a[SearchDocumentType.Programs] = 29,
    _a[SearchDocumentType.ProGallery] = 54,
    _a);
var DEFAULT_TOTAL_COUNT = 10;
export function getTotalCount(documentType) {
    var _a;
    return (_a = totalCounts[documentType]) !== null && _a !== void 0 ? _a : DEFAULT_TOTAL_COUNT;
}
//# sourceMappingURL=getTotalCount.js.map